<template>
  <section>
    <div v-if="data && data.length">
      <div v-for="d in data" :key="d.id">
        <div
          class="flex justify-between items-center p-2 px-4 bg-gray-lighter rounded-lg mb-2"
        >
          <div>
            <h3 class="text-sm text-gray-dark font-bold">
              {{ getFormattedDate(d.start_date, d.timezone, 'MMM DD, YYYY (ddd)') }}
            </h3>
            <p class="text-xs text-gray-light">
              {{ getFormattedDate(d.start_date, d.timezone, 'h:mm A') }} -
              {{ getFormattedDate(d.end_date, d.timezone, 'h:mm A') }}
            </p>
          </div>
          <button
            type="button"
            class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-white hover:text-green-light"
            @click="$emit('batch-id', d.id)"
            v-if="d.cost"
          >
            Book
          </button>
          <!-- :to="{
              name: 'UserSessionLive',
              params: { id: d.id },
            }" -->
          <button
            type="button"
            class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-white hover:text-green-light"
            @click="onclickBookFreeClass(d.id)"
            v-else
          >
            Book
          </button>
        </div>
      </div>
    </div>
    <span class="text-xs text-gray-700" v-else>
      No slots available or scheduled for this class
    </span>
    <ConfirmationModal
      modalTitle="Booking Confirmation"
      modalQuestion="Are you sure you want to Book Free Class ?"
      :isCancellable="true"
      modalConfirmText="Confirm"
      :confirmationModalOpen="bookingConfirmation"
      :modalCancelHandler="toggleBookingConfirmation"
      :confirmModalHandler="freeBookingConfirmationHandler"
    ></ConfirmationModal>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ConfirmationModal} from '@/components/t-components'
export default {
  name: "SessionBatchesAvailable",
  components: {
    ConfirmationModal
  },
  data () {
    return {
      bookingConfirmation: false,
      bookingInfo: null
    }
  },
  props: {
    data: {
      type: Array,
    },
    type: {
      type: String,
    },
    handleFooterPopper: Function,
  },
  computed: {
    ...mapGetters(["userBookFreeClass"]),
  },
  methods: {
    ...mapActions(["postUserBookFreeClass"]),

    onclickBookFreeClass(id) {
      if (this.getToken()) {
        this.bookingInfo = {
          entityId: this.$route.params && this.$route.params.id, // SessionID
          entityType: 1, // SESSION CONSTANT
          batchId: id, // BatchID
          paymentStatus: "free",
        };
        this.toggleBookingConfirmation()
      } else {
        this.$store.commit('setAuthModalActive', true)
      }
      
      
      
    },
    toggleBookingConfirmation () {
      this.bookingConfirmation = !this.bookingConfirmation
    },
    freeBookingConfirmationHandler () {
      this.toggleBookingConfirmation()
      this.postUserBookFreeClass(this.bookingInfo).then(() => {
        setTimeout(() => window.location.reload(), 1000);
      })
    }
  },
};
</script>